<template>
  <div>
    <QuizEditorNav />
    <br><br>
    <div class="container loader" v-if="quizLoading" style="margin-top: 84px;">
      <div class="progress">
        <div class="indeterminate"></div>
      </div>
    </div>
    <p><br>
    <div class="container " v-if="!quizLoading">
      <div class="tutorial-info">
        <div class="preview-title">{{title}}</div>
        <div class="preview-description">{{description}}</div>
      </div>
    </div>

    <div class="container" v-if="!quizLoading">
      <div class="row">
    <div class="col s12 m4">
      <div class="card light-blue darken-2">
        <div class="card-content white-text">
          <span class="card-title center">Total Quizzes Taken</span>
          <p><h1 class="center">{{quiz.quiz_results.length}}</h1></p>
        </div>
        
      </div>
      
    </div>
    <div class="col s12 m4">
      <div class="card green darken-2">
        <div class="card-content white-text">
          <span class="card-title center">Total Passes</span>
          <p><h1 class="center">{{quiz.total_pass.aggregate.count}}</h1></p>
        </div>
        
      </div>
    </div>
    <div class="col s12 m4">
      <div class="card blue-grey darken-1">
        <div class="card-content white-text">
          <span class="card-title center">Average Score</span>
          <p><h1 class="center">{{Math.ceil(quiz.averager.aggregate.avg.score)}}%</h1></p>
        </div>
        
      </div>
    </div>
  </div>
  <!--<v-chart :options="bar"/>-->
    </div>

    <div class="container">
      <br>
      <datatable
      title="Completed Quizzes"
      :columns="columns"
      :rows="rows">
      </datatable>
      
    </div>
  </div>
</template>

<script>
import QuizEditorNav from "@/components/QuizEditorNav";
import QuizStepper from "@/components/QuizStepper";
import moment from 'moment';
import DataTable from "vue-materialize-datatable"
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'

import cognitoAuth from "@/plugins/cognito";
//import GqlQuery from "@/plugins/gql";
import GqlV2Query from "@/plugins/gqlV2"

export default {
  mounted() {
    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function(err, user_attributes) {
          self.user_org = user_attributes['custom:organization_id'];
          self.user_email = user_attributes['email'];
           if (self.id) {
            self.loadQuiz();
            self.loadQuizGraphSummary()
           }
        });
      }
    });
    var self = this;
  },
  updated() {},
  name: "Preview",
  data() {
    return {
      columns: [
        {label:'Date', field:'created_at'}, {label:'Name', field:'name' }, {label:'Email', field:'email'}, {label:'Result', field:'result'}, {label:'Score (%)',field:'score', numeric: true}
        ],
      rows: [],
      id: this.$route.params.id,
      quiz: {},
      processing: false,
      quizLoading: true,
      title: "Loading",
      description: "-",
      user_org: false,
      user_email: false,
      results_table:{},
      bar: {
        title: {
          text: 'Quizzes by date'
        },
        tooltip: {},
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: 'Passing',
          type: 'bar',
          color: 'green',
          data: []
        },{
          name: 'Failing',
          type: 'bar',
          color: 'red',
          data: []
        }]
      }
    };
  },
  filters:{
    formatDate(value){
      if (value) {
        return moment.utc(String(value)).local().format('MM/DD/YYYY hh:mm a')
      }
    },
  },
  methods: {
    selectionChanged(ref){
      console.log('selection changed')
    },
    getRows(){
      let self=this;
      let results=[];
      if(self.quiz!=undefined){
        self.quiz.quiz_results.forEach(result => {
          let pass_status='Passed'
          if(!result.result){
            pass_status="Failed"
          }
          let scorer=.0;
          if(result.score){
            scorer=`${result.score}`
          }
          let quiz_result={id:result.id, name:result.name, email:result.email, score:scorer,result:pass_status, created_at:this.$options.filters.formatDate(result.created_at) }
          results.push(quiz_result)
        })
      }
      self.rows=results;
    },
    setProcessing(value) {
      this.processing = value;
    },

    loadQuiz(){
      let self = this;
      GqlV2Query.getQuizWithResults(this.id,  (err, result) => {
        let quiz=result.data.quiz[0];
        self.quiz=quiz;
        self.originalQuiz = quiz;
        self.title=quiz.title;
        self.description=quiz.description;
        self.time_to_complete=quiz.time_to_complete;
        self.quizLoading = false;
        M.AutoInit();
       self.getRows();
      });
    },
    loadQuizGraphSummary(){
      let self = this;
      GqlV2Query.getQuizSummaryResults(this.id,  (err, result) => {
        if(err){
          console.log(JSON.stringify(err))
        } else{
         result.data.quiz_results_summary.forEach (grapher =>{
           self.bar.xAxis.data.push(grapher.dater)
           if(grapher.result){
             self.bar.series[0].data.push(grapher.count)
           }else{
             self.bar.series[1].data.push(grapher.count)
           }
         })
        }
        M.AutoInit();
        self.$forceUpdate()
      });
    },

    
  },
  components: {
    QuizEditorNav,
    QuizStepper,
    "datatable":DataTable,
    "v-chart":ECharts
  }
};
</script>

<style scoped>
#toast-container {
  min-width: 10%;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  margin-top: -69px;
}
</style>
<style scoped>
.preview-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.preview-actions {
  text-align: right;
  flex-shrink: 0;
}
h2 {
  color: #58595b;
  font-family: Roboto;
  font-size: 24px;
  line-height: 32px;
  margin-top: 60px;
  margin-bottom: 24px;
}
button {
  margin-left: 10px;
}
.time-to-complete label {
  left: 0;
}
.right.helper-text {
  text-align: right;
}
.btn-flat {
  color: #27aae1;
}
.btn {
  font-weight: 500;
}
.btn-flat:hover {
  color: white;
  background-color: #27aae1;
}
.progress {
  background-color: #7ac7e7;
}
.progress .determinate,
.progress .indeterminate {
  background-color: #29abe1;
}
.preview-title {
  color: rgba(0,0,0,0.87);	font-family: Roboto;	font-size: 16px;	line-height: 24px;
}
.preview-description {
  color: rgba(0,0,0,0.54);	font-family: Roboto;	font-size: 14px;	line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/quizzes/QuizResults.vue